<template>
  <!-- New -->
  <div class="wallboard-preview">
    <div class="screenshot" v-on:click="onSelect">
      <img :src="wallboard.screenshot || constants.API + 'screenshots/screenshot' + wallboard.id + '.jpg?' + now" alt="Screenshot">
    </div>
    <div class="content">
      <div class="wallboard-name">
        <p>{{wallboard.name}}</p>
      </div>
      <div class="state-tools">
        <div class="state">
          <p>{{wallboard.public ? 'Public' : 'Private'}}</p>
        </div>
        <div class="tools">
          <ul>
            <li><a href="#!" v-on:click="onDelete"><i class="far fa-trash-alt"></i></a></li>
            <li><a href="#!"><i class="fas fa-eye" v-on:click="onSelect"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Old -->
  <!-- <div class="wallboardPreview">
    <div class="screenshot" v-on:click="onSelect">
      <div class="screenshotHolder">
        <div class="screenshotImage" :style="{ 'background-image': 'url(' + (wallboard.screenshot || constants.API + 'screenshots/screenshot' + wallboard.id + '.jpg?' + now) + ')' }"/>
      </div>
      <div class="toolbar">
        <div class="options">
          <span class="icon far fa-edit"></span>
          <span class="icon far fa-trash-alt" v-on:click="onDelete"></span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="flexBetween">
        <p class="textMd">{{wallboard.name}}</p>
        <div class="pillList">
          <div class="pill first clickable" :class="{secondary: wallboard.public, primary: !wallboard.public}">{{wallboard.public ? 'Public' : 'Private'}}</div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import constants from "../../utils/constants.js";
export default {
  props: ["wallboard", "onSelect", "onDelete"],
  data() {
    return {
      constants,
      now: Date.now()
    };
  }
};
</script>

<style scoped lang="scss">
  .wallboard-preview {
    position: relative;
    height: 270px;
    background: $white;
    border-radius: 3px;
    @include box-shadow(0px, 0px, 10px, lighten($backgroundColour, 70%));
    .screenshot {
      height: 194px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        object-fit: cover;
        border-radius: 3px 3px 0 0;
      }
    }
    .content {
      padding: 15px;
      box-sizing: border-box;
      .wallboard-name {
        p {
          color: lighten($black, 40%);
        }
      }
      .state-tools {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .state {
          p {
            font-size: 12px;
            text-transform: uppercase;
            color: lighten($black, 50%);
          }
        }
        .tools {
          ul {
            margin: 0;
            padding: 0;
            list-style: none;
            li {
              display: inline-block;
              margin-left: 15px;
              &:first-child {
                margin-left: 0;
              }
              a {
                transition: all 0.2s ease;
                color: $primary;
                &:hover, &:focus, &:active {
                  color: darken($primary, 5%);
                }
              }
            }
          }
        }
      }
    }
  }
</style>